exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".righthead[data-v-f2b3fbc6]{height:64px;background:#2c3e50;box-shadow:0 1px 4px rgba(0,21,41,.08);position:relative;z-index:1;color:#e6f7ff}.userinfo[data-v-f2b3fbc6]{float:right}.logout[data-v-f2b3fbc6],.userinfo[data-v-f2b3fbc6]{width:120px;height:64px;line-height:64px;cursor:pointer}.logout[data-v-f2b3fbc6]{position:absolute;right:0;top:64px;color:#fff;background:#f56c6c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2b3fbc6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/Header.vue
// module id = 146
// module chunks = 0